var map = {
	"./lifeBlock/lifeBlock_1_en.png": "86e9",
	"./lifeBlock/lifeBlock_1_zh.png": "1b21",
	"./lifeBlock/lifeBlock_2_en.png": "3312",
	"./lifeBlock/lifeBlock_2_zh.png": "4b65",
	"./lifeBlock/lifeBlock_3_en.png": "80e7",
	"./lifeBlock/lifeBlock_3_zh.png": "c65d",
	"./lifeBlock/lifeBlock_4_en.png": "0bf6",
	"./lifeBlock/lifeBlock_4_zh.png": "8bda",
	"./lifeBlock/lifeBlock_5_en.png": "505f",
	"./lifeBlock/lifeBlock_5_zh.png": "4980",
	"./lifeBlock/lifeBlock_6_en.png": "a293",
	"./lifeBlock/lifeBlock_6_zh.png": "174c",
	"./lifeBlock/lifeBlock_7_en.png": "2497",
	"./lifeBlock/lifeBlock_7_zh.png": "9df9",
	"./lifeBlock/lifeBlock_8_en.png": "77ab",
	"./lifeBlock/lifeBlock_8_zh.png": "ed3e",
	"./lifeBlock/lifeBlock_9_en.png": "9ab7",
	"./lifeBlock/lifeBlock_9_zh.png": "27a8",
	"./teaching/teaching_1_en.png": "4c9a",
	"./teaching/teaching_1_zh.png": "8b41",
	"./teaching/teaching_2_en.png": "a8d2",
	"./teaching/teaching_2_zh.png": "5fab",
	"./teaching/teaching_3_en.png": "6b46",
	"./teaching/teaching_3_zh.png": "ece6",
	"./teaching/teaching_4_en.png": "b3db",
	"./teaching/teaching_4_zh.png": "8ee9",
	"./teaching/teaching_5_en.png": "8a8f",
	"./teaching/teaching_5_zh.png": "fa05",
	"./teaching/teaching_6_en.png": "f518",
	"./teaching/teaching_6_zh.png": "20fb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e8cc";